<template>
  <div
    class="app-content content h-100"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />

    <div
      v-if="loader"
      id="loading-bg"
      class="global-preloader"
    >

      <div class="loading">
        <div class="effect-1 effects" />
        <div class="effect-2 effects" />
        <div class="effect-3 effects" />
      </div>
    </div>
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper h-100"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div class="content-body h-100">
        <div class="d-sm-none w-100 mb-1">
          <pages-dropdown
            variant="gradient-primary"
            block
          />
        </div>

        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import PagesDropdown from '@/@bya3/components/navbar/PagesDropdown'

export default {
  components: {
    PagesDropdown,
    AppBreadcrumb,
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
  computed: {
    loader() {
      return this.$store.getters['auth/loader']
    },
  },
}
</script>

<style>
.global-preloader{
  position: absolute;
  top:0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 99999;
  background-color: rgba(0,0,0,0.2) !important;
}
</style>
